import { render, staticRenderFns } from "./FormGroupInput.vue?vue&type=template&id=1cf04fb2&"
import script from "./FormGroupInput.vue?vue&type=script&lang=js&"
export * from "./FormGroupInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports